type IconName = 'star' | 'sparkle' | 'crown' | 'flame' | 'clock' | 'fork' | 'check' | 'chevron' | 'filter'

interface IconProps {
  name: IconName
  size?: number
}

const Icon = ({name, size = 14}: IconProps) => {
  const common = {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.6,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
  }
  switch (name) {
    case 'star':
      return (
        <svg {...common}>
          <path
            d="M12 2.5l2.6 5.3 5.9.85-4.25 4.15 1 5.85L12 15.85 6.75 18.65l1-5.85L3.5 8.65l5.9-.85L12 2.5z"
            fill="currentColor"
            stroke="none"
          />
        </svg>
      )
    case 'sparkle':
      return (
        <svg {...common}>
          <path d="M12 3l1.7 5.3L19 10l-5.3 1.7L12 17l-1.7-5.3L5 10l5.3-1.7L12 3z" fill="currentColor" stroke="none" />
        </svg>
      )
    case 'crown':
      return (
        <svg {...common}>
          <path d="M3 18l2-10 5 5 2-8 2 8 5-5 2 10H3z" fill="currentColor" stroke="none" />
        </svg>
      )
    case 'flame':
      return (
        <svg {...common}>
          <path d="M12 3s4 4 4 8a4 4 0 11-8 0c0-2 1-3 1-3s.5 1.5 1.5 1.5C10 7 12 3 12 3z" />
        </svg>
      )
    case 'clock':
      return (
        <svg {...common}>
          <circle cx="12" cy="12" r="9" />
          <path d="M12 7v5l3 2" />
        </svg>
      )
    case 'fork':
      return (
        <svg {...common}>
          <circle cx="6" cy="6" r="2" />
          <circle cx="18" cy="6" r="2" />
          <circle cx="12" cy="20" r="2" />
          <path d="M6 8v2a3 3 0 003 3h6a3 3 0 003-3V8M12 13v5" />
        </svg>
      )
    case 'check':
      return (
        <svg {...common}>
          <path d="M5 12l5 5L20 7" />
        </svg>
      )
    case 'chevron':
      return (
        <svg {...common}>
          <path d="M6 9l6 6 6-6" />
        </svg>
      )
    case 'filter':
      return (
        <svg {...common}>
          <path d="M3 5h18M6 12h12M10 19h4" />
        </svg>
      )
    default:
      return null
  }
}

export default Icon
